import React, { Component } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import LoadScript from "./LoadScript";
import { PATH_PRIVATE } from "../routes/paths";
import { elements } from "../routes/elements";

function Sidebar() {
  return (
    <div className="sticky d-flex flex-column">
      <div className="app-sidebar__overlay" data-bs-toggle="sidebar"></div>
      <div className="app-sidebar sidemenu-scroll">
        <div className="side-header">
          <a className="header-brand1" href="">
            <img
              src="./assets/images/Dahab.png"
              className="header-brand-img desktop-logo"
              alt="logo"
            />
            <img
              src="./favicon.ico"
              className="header-brand-img toggle-logo"
              alt="logo"
            />
            <img
              src="./favicon.ico"
              className="header-brand-img light-logo"
              alt="logo"
            />
            <img
              src="./assets/images/DahabGreen.png"
              className="header-brand-img light-logo1"
              alt="logo"
            />
          </a>
          {/* <!-- LOGO --> */}
        </div>
        <div
          className="main-sidemenu"
          style={{ overflowY: "scroll", height: "100%" }}
        >
          <div className="slide-left vh-100" id="slide-left">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#7b8191"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" />
            </svg>
          </div>
          <ul className="side-menu">
            <li>
              <h3>Menu</h3>
            </li>

            {elements.filter(element => !element.HideInSidebar).map((element) => {
              return element.Path.includes(PATH_PRIVATE.GetToken) ? (
                <>
                  <h3>Authentication</h3>
                  <li className="slide">
                    <Link
                      className="side-menu__item has-link"
                      data-bs-toggle="slide"
                      to={element.Path}
                    >
                      {element.Icon}
                      <span className="side-menu__label">{element.Name}</span>
                    </Link>
                  </li>
                </>
              ) : element.Path.includes(PATH_PRIVATE.GetAgents) ? (
                <>
                  <h3>API REFERENCES</h3>
                  <li className="slide">
                    <Link
                      className="side-menu__item has-link"
                      data-bs-toggle="slide"
                      to={element.Path}
                    >
                      {element.Icon}
                      <span className="side-menu__label">{element.Name}</span>
                    </Link>
                  </li>
                </>
              ) : (
                <li className="slide">
                  <Link
                    className="side-menu__item has-link"
                    data-bs-toggle="slide"
                    to={element.Path}
                  >
                    {element.Icon}
                    <span className="side-menu__label">{element.Name}</span>
                  </Link>
                </li>
              );
            })}
           
          </ul>
          <div className="d-block d-md" style={{ marginTop: "30px" }} />
        </div>
        <div className="ps__rail-x" style={{ left: 0, bottom: -378 }}>
          <div className="ps__thumb-x" style={{ left: 0, width: 0 }}></div>
        </div>
        <div className="ps__rail-y" style={{ top: 374, height: 505, right: 0 }}>
          <div className="ps__thumb-y" style={{ top: 215, height: 290 }}></div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
